import React from 'react';
import SMReservationCalendarBaseView from './SMReservationCalendarBaseView';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMRoomResource from 'resources/SMRoomResource';

class SMReservationCalendarMobileView extends SMReservationCalendarBaseView {

  constructor(props) {
    super(props);

    this.dayDidSelect = this.dayDidSelect.bind(this);
  }

  dayDidSelect(selectedDay, e) {
    e.preventDefault();
    if (this.props.isHourly == 1) {
      this.setState({
        day: selectedDay,
      });
      setTimeout(()=>{
        this.requestDailyResource();
      }, 1);
    } else {

      const plan = this.props.plan;
      const startedAt = new Date(Date.UTC(this.state.year, this.state.month - 1, selectedDay));
      let isSessionStart = false;
      let duration = 60 * 24;
      if (plan.has_session_price) {
        duration *= plan.min_required_session_hour;
        isSessionStart = true;
      }
      this.props.delegate.scheduleDidSelect(startedAt, duration, isSessionStart);
    }
  }

  requestDailyResource() {
    const plan = this.props.plan;
    let queries = SMPlanHelper.isRoom(plan) ? {} : {plan_id: plan.id};
    queries.year = this.state.year;
    queries.month = this.state.month;
    queries.day = this.state.day;
    queries.is_hourly = this.props.isHourly;

    $(this.refs.dailyTable).startLoading();
    SMRoomResource.getCalendar(this.props.room.id, queries, (calendars, error)=>{
      $(this.refs.dailyTable).stopLoading();
      if(!error) {
        this.props.delegate.dayDidSelect(this.state.year, this.state.month, this.state.day, calendars);
      }
    });
  }

  requestMonthlyResource(date) {
    const plan = this.props.plan;

    let queries = SMPlanHelper.isRoom(plan) ? {} : {plan_id: plan.id};
    queries.year = date.getFullYear();
    queries.month = date.getMonth() + 1;
    queries.is_hourly = this.props.isHourly;

    $(this.refs.calendarContainer).startLoading();
    SMRoomResource.getCalendar(this.props.room.id, queries, (calendars, error)=>{
      $(this.refs.calendarContainer).stopLoading();
      if(!error) {
        this.setState({
          monthlyCalendars: calendars,
          year: queries.year,
          month: queries.month,
        });
      }
    });
  }

  renderMonthly() {
    let weekDay = 0;
    let rows = [];
    let cols = [];
    const monthFirst = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month - 1, 1)));
    const monthLast = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month, 0)));
    const now = new Date();
    const interval = 60 * 24;

    this.state.monthlyCalendars.forEach((calendar, index)=>{
      let classes = [];
      const currentDate = new Date(Date.UTC(calendar.year, calendar.month - 1, calendar.day));
      const current = this.toYMD(currentDate);

      let isCurrentMonth = true;

      if (cols.length == 0 || cols.length == 6) {
        //classes.push("is-holiday");
      }
      if (current < monthFirst) {
        isCurrentMonth = false;
      }
      if (current > monthLast) {
        isCurrentMonth = false;
      }
      if (current == this.toYMD(now)) {
        classes.push("is-today");
      }
      if (this.state.month == calendar.month && this.state.day == calendar.day) {
        classes.push("is-select");
      }
      this.props.reservation.reserved_schedules.forEach((schedule)=>{
        for (var i = 0; i < schedule.duration; i += interval) {
          const date = new Date(schedule.started_at);
          date.setUTCDate(date.getUTCDate() + i / interval);
          if (current == this.toYMD(date)) {
            if (this.props.plan.has_session_price) {
              if (i == 0) {
                classes.push("is-checked");
                classes.push("is-reserved");
              } else {
                classes.push("is-reserved");
              }
            } else {
              classes.push("is-checked");
              classes.push("is-reserved");
            }
            return true;
          }
        }
      });
      const key = current;

      if (!isCurrentMonth) {
        classes.push("is-past");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done"></p>
            </div>
          </td>
        );
      }
      else if(calendar.status == SMConst.RoomStatus.Available) {
        const priceSuffix = this.props.isHourly ? "〜" : "";
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <a onClick={(e) => this.dayDidSelect(calendar.day, e)} href="#" className="dashboard-calendar__cell-wrap">
              <p className="dashboard-calendar__date">{calendar.day}</p>
              <div className="reserve-period__calendar-content">
                <p className="reserve-period__calendar-price">{calendar.price_text}{priceSuffix}</p>
                <p className="reserve-period__calendar-check"><i className="fa fa-check"></i></p>
              </div>
            </a>
          </td>
        );
      }
      else if (calendar.status == SMConst.RoomStatus.Full || calendar.status == SMConst.RoomStatus.Request) {
        classes.push("is-unavailable");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done">{calendar.status_text}</p>
            </div>
          </td>
        );
      }
      else {
        classes.push("is-closed");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done">{calendar.status_text}</p>
            </div>
          </td>
        );
      }

      if (cols.length == 7) {
        rows.push(<tr key={rows.length}>{cols}</tr>);
        cols = [];
      }
    });
    rows.push(<tr key={rows.length}>{cols}</tr>);
    return rows;
  }

  render() {

    const room = this.props.room;
    const yearText = sprintf("%s年", this.state.year);
    const monthText = sprintf("%s月", this.state.month);
    const timeStyle = {display: "none"};

    return(
      <div ref="calendarContainer" className="js-monthly-table__container sp-reserve-card">
        <div className="sp-reserve-card__inner clearfix">
          <div className="sp-reserve-card__inner__calendar">
            <div className="sp-reserve-period__header">
              <a onClick={this.prevMonth} href="#" className="sp-reserve-period__header-navi"><i className="fa fa-angle-left"></i></a>
              <h2 className="sp-reserve-period__title">{yearText}<span className="sp-reserve-period__title-month">{monthText}</span></h2>
              <a onClick={this.nextMonth} href="#" className="sp-reserve-period__header-navi"><i className="fa fa-angle-right"></i></a>
            </div>
            <table ref="monthlyTable" className="js-monthly-table sp-reserve-period__calendar dashboard-calendar__table">
              <tbody>
                <tr>
                  <th className="is-holiday">{I18n.t("datetime.Sun")}</th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Mon")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Tue")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Wed")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Thu")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Fri")}</div></th>
                  <th className="is-holiday">{I18n.t("datetime.Sat")}</th>
                </tr>
                {this.renderMonthly()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

}
export default SMReservationCalendarMobileView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationCalendarMobileView.jsx